var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"dense":"","disable-pagination":"","hide-default-footer":"","items":_vm.menu,"headers":_vm.tableHeaders},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('tr',[_c('td',{domProps:{"textContent":_vm._s(item.name)}}),_c('td',{domProps:{"textContent":_vm._s(_vm.formatCurrency(item.price))}})])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }